export const DivisorX = () => {
  return <hr className={`divisor-claro w-full border-1`}></hr>;
};
